export function alert(state) {
  return state.alert;
}
